<script lang="ts">
    const { error }: { error: Error } = $props();
    throw error;
</script>
